export function formatTimeAgo(timestamp, verbose = true) {
    if (timestamp == undefined || (typeof timestamp !== 'string' && isNaN(timestamp))) return "--";
    let date = new Date(timestamp);
    const now = new Date();
    const seconds = Math.floor((now - date) / 1000);
    let interval;
    let prefix = '';

    interval = Math.floor(seconds / 31536000); // Years
    if (interval >= 1) {
        const roundedYears = Math.round(seconds / 31536000);
        prefix = verbose && roundedYears > interval ? 'less than ' : verbose ? 'more than ' : '';
        return roundedYears === 1 ? `${prefix}1 year ago` : `${prefix}${roundedYears} years ago`;
    }

    interval = Math.floor(seconds / 2592000); // Months (30 days)
    if (interval >= 1) {
        const roundedMonths = Math.round(seconds / 2592000);
        prefix = verbose && roundedMonths > interval ? 'less than ' : verbose ? 'more than ' : '';
        return roundedMonths === 1 ? `${prefix}1 month ago` : `${prefix}${roundedMonths} months ago`;
    }

    interval = Math.floor(seconds / 86400); // Days
    if (interval >= 1) {
        const roundedDays = Math.round(seconds / 86400);
        prefix = verbose && roundedDays > interval ? 'less than ' : verbose ? 'more than ' : '';
        return roundedDays === 1 ? `${prefix}1 day ago` : `${prefix}${roundedDays} days ago`;
    }

    interval = Math.floor(seconds / 3600); // Hours
    if (interval >= 1) {
        const roundedHours = Math.round(seconds / 3600);
        prefix = verbose && roundedHours > interval ? 'less than ' : verbose ? 'more than ' : '';
        return roundedHours === 1 ? `${prefix}1 hour ago` : `${prefix}${roundedHours} hours ago`;
    }

    interval = Math.floor(seconds / 60); // Minutes
    if (interval >= 1) {
        const roundedMinutes = Math.round(seconds / 60);
        prefix = verbose && roundedMinutes > interval ? 'less than ' : verbose ? 'more than ' : '';
        return roundedMinutes === 1 ? `${prefix}1 minute ago` : `${prefix}${roundedMinutes} minutes ago`;
    }

    return 'Just now';
}

export function formatExactTime(timestamp) {
    if (timestamp == undefined) return "--";
    let date = new Date(timestamp);
    let dateLocaleString = date.toLocaleString();
    return dateLocaleString;
}